import { inject, Injectable } from '@angular/core';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import { Observable } from 'rxjs';
import { filesModel } from '../../../../../apps/cinari-erp-client/src/app/dashboard-module/models/dashboard-models';

@Injectable({
  providedIn: 'root'
})
export class DeletedFilesService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  getDeletedFiles(fromDate: string, toDate: string): Observable<filesModel[]> {
    return this.#http.getData<filesModel[]>(
      `${this.baseUrl}/filesystem/inactive?FromDate=${fromDate}&ToDate=${toDate}&IsValidDateRange=true`,
      { showLoader: true, showMessage: false }
    );
  }

  bulkRestore(fileIds: string[]): Observable<any> {
    return this.#http.postData<any>(
      `${this.baseUrl}/filesystem/bulk-restore`,
      { showLoader: true, showMessage: true, message: 'Success!' },
      fileIds
    );
  }

  bulkPermanentDelete(fileIds: string[]): Observable<any> {
    return this.#http.postData<any>(
      `${this.baseUrl}/filesystem/bulk-permanent-delete`,
      { showLoader: true, showMessage: true, message: 'Success!' },
      fileIds
    );
  }
}
